import store from "@basic/store"

export default new store();
